import { DateRangeIcon } from '@mui/x-date-pickers';
import moment from 'moment-timezone';
import { createContext, useContext, useEffect, useState } from 'react';
import { useAllGlobalSettingsQuery } from 'src/api/GlobalSettingsRepository';
import { CountryCode, GlobalSetting, SymbolPosition } from 'src/models/GlobalSetting';

type Props = {
  children: React.ReactNode;
};

const countryTimezones: Record<string, string> = {
  ES: 'Europe/Madrid',
  MX: 'America/Mexico_City',
};

const Context = createContext<GlobalSetting>({} as GlobalSetting);

export const GlobalSettingsProvider: React.FC<Props> = ({ children }) => {
  const { data } = useAllGlobalSettingsQuery();

  const defaultSettings:GlobalSetting = {
    currency: {
      code: "eur",
      position: SymbolPosition.AFTER,
      symbol: "€",
      precision: 2,
      thousand_separator: ".",
      decimal_separator: ",",
    },
    country: {
      code: CountryCode.ES,
      name: "España",
    },
    server_time: "",
    client_time: "",
  };

  const [settings, setSettings] = useState<GlobalSetting>(defaultSettings);

  useEffect(() => {
    
    if (data) {
      const timezone = countryTimezones[data.country?.code] || 'UTC';
      console.log('timezone', timezone);
      var server_time = moment(data.server_time).utc().format(); 
      console.log('server_time', server_time);
      var client_time = moment(data.server_time).tz(timezone).format("YYYY-MM-DDTHH:mm:ss[Z]");
      console.log('client_time', client_time);

      setSettings({
        ...data,
        server_time,
        client_time,
      });
    }
  }, [data]);

  return <Context.Provider value={settings}>{children}</Context.Provider>;
};

export const useGlobalSettingsContext = () => {
  const context = useContext(Context);

  if (context.currency === undefined) throw new Error('global settings not found');

  return context;
};
